import { render } from "./ApplicationsListEmpty.vue?vue&type=template&id=6118bdbe"
import script from "./ApplicationsListEmpty.vue?vue&type=script&lang=js"
export * from "./ApplicationsListEmpty.vue?vue&type=script&lang=js"

import "./ApplicationsListEmpty.vue?vue&type=style&index=0&id=6118bdbe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__